// export const DOMAIN_API = 'http://localhost:8000/api/';
// export const DOMAIN_API = 'https://e-vent-api.imcorrs.com/api/'
export const DOMAIN_API = 'https://e-vent-api.expodiseno.com/api/'

export const KEY_USER = "USER_APP_E-VENT";
export const KEY_STORAGE = "STORAGE_KEY_APP_E-VENT";